import * as React from "react";
import LoaderComponent from "../Loader";
import { useActivityTemplates } from "@container/CreationForms/AddEditActivity/hooks/useActivityTemplates";

const DEFAULT_TEMPLATE_ITEM = Object.freeze({
    id: 0,
    name: "Default",
    template_short_name: null,
    isDefault: true,
});

const ChooseActivityTemplate = (props) => {
    const {
        title,
        error,
        showReason,
        isCreateActivity,
        modalBodyClass,
        setActivity,
    } = props;

    const { templates, areTemplatesLoading } = useActivityTemplates();

    const [selectedId, setSelectedId] = React.useState(null);

    const options = React.useMemo(
        () => [...templates, DEFAULT_TEMPLATE_ITEM],
        [templates],
    );

    const handleSelect = (item) => {
        setSelectedId(item.id);
        setActivity({
            Id: item.id,
            TemplateShortName: item.template_short_name,
            TemplateName: item.name,
            name: item.name,
            template_short_name: item.template_short_name,
            isDefault: !!item.isDefault,
        });
    };

    const modalBody = (
        <React.Fragment>
            {showReason ? (
                <p className="rowFlex alignMiddle mt__1">
                    <label>{title}</label>
                    {error ? (
                        <span className="errorSelfMsg ml">Activity required</span>
                    ) : (
                        ""
                    )}
                </p>
            ) : null}
            <div className="activityTemplate col-3">
                {areTemplatesLoading ? (
                    <LoaderComponent />
                ) : (
                    <ul className="wrapFlex">
                        {options.map((item) => (
                            <li className="alignMiddle" key={`template_${item.id}`}>
                                <input
                                    type="radio"
                                    name="activity_template"
                                    className="gap"
                                    id={`template_${item.id}`}
                                    checked={selectedId === item.id}
                                    onChange={() => handleSelect(item)}
                                />
                                <label htmlFor={`template_${item.id}`}>
                                    {item.name}
                                </label>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </React.Fragment>
    );

    if (isCreateActivity && showReason) return modalBody;

    return (
        <div className={modalBodyClass ? modalBodyClass : "modalBody"}>
            {modalBody}
        </div>
    );
};

export default ChooseActivityTemplate;